import React, { useEffect, useState } from "react";
import { useHistory,useNavigate,useLocation } from "react-router";
import $ from "jquery";
import axios from "axios";
import ReqService from '../../request/service';
import Waiter from './../../assets/gif/blueCircle.gif';
import CopySound from './../../assets/sound/beep07a.wav';
import { createGlobalStyle } from 'styled-components';
import {URLPREFIX,API_CORE_SERVER,RS_LABEL,DDMMYYYY_LABEL} from '../../constants';
import {stringToHex} from "../forms/validator";
const GlobalStyles = createGlobalStyle`
#mapid { height: 580px; }
.bg-black-95 { background:rgba(245,240,240,0.85); }
`;

const JComponent = (props) => { 
	const navigate=useNavigate();
	const location = useLocation();
	const [assetsCategoryList,setAssetsCategoryList]=useState([]);
	const [implAgencyList,setImplAgencyList]=useState([]);
  	const [fundingAgencyList,setFundingAgencyList]=useState([]);
  	const [userAgencyList,setUserAgencyList]=useState([]);
	const [item,setItem]=useState({});
	let _TX=1;
	
    useEffect(()=>{
        if(_TX==1)
        {_TX++;
			loadAssetCategoryList();
			loadFundingAgencyList();
			loadImplAgencyList();
			loadUserAgencyList();
			fetchData();
		}
    
    },[])
	const getAssetType=(_catId)=>{
		for(let i=0;i<assetsCategoryList.length;i++){
			if(assetsCategoryList[i].catId===_catId) return(assetsCategoryList[i].catName);
		}
		return(_catId);
	}
	const getImplAgencyById=(_id)=>{
		for(let i=0;i<implAgencyList.length;i++){
			if(implAgencyList[i].implAgencyId===_id) return(implAgencyList[i].implAgencyName);
		}
		return(_id);
	}
	const getUserAgencyById=(_id)=>{
		for(let i=0;i<userAgencyList.length;i++){
			if(userAgencyList[i].userAgencyId===_id) return(userAgencyList[i].userAgencyName);
		}
		return(_id);
	}
	const loadAssetCategoryList=()=>{
		var config = {
			method: 'post',
			url: API_CORE_SERVER+"/api/get_asset_category.php",
			headers: { 
				//'Content-Type': 'application/x-www-form-urlencoded',
				'Content-Type': 'application/json', 
			},
			data:{name:'hellominni'}
		  };
		axios(config)
			.then((response)=>{
				if(response.status===200 && response.data){
					setAssetsCategoryList(response.data);
				}
				
			}).catch((response)=>{
				console.log(response);
			})
	  }
	  const loadImplAgencyList=()=>{
		var config = {
			method: 'post',
			url: API_CORE_SERVER+"/api/get_impl_agency.php",
			headers: { 
				//'Content-Type': 'application/x-www-form-urlencoded',
				'Content-Type': 'application/json', 
			},
			data:{name:'hellominni'}
		  };
		axios(config)
			.then((response)=>{
				if(response.status===200 && response.data){
					setImplAgencyList(response.data);
				}
				
			}).catch((response)=>{
				console.log(response);
			})
	  }
	  const loadFundingAgencyList=()=>{
		var config = {
			method: 'post',
			url: API_CORE_SERVER+"/api/get_funding_agency.php",
			headers: { 
				//'Content-Type': 'application/x-www-form-urlencoded',
				'Content-Type': 'application/json', 
			},
			data:{name:'hellominni'}
		  };
		axios(config)
			.then((response)=>{
				if(response.status===200 && response.data){
					setFundingAgencyList(response.data);
				}
				
			}).catch((response)=>{
				console.log(response);
			})
	  }
	  const loadUserAgencyList=()=>{
		var config = {
			method: 'post',
			url: API_CORE_SERVER+"/api/get_user_agency.php",
			headers: { 
				//'Content-Type': 'application/x-www-form-urlencoded',
				'Content-Type': 'application/json', 
			},
			data:{name:'hellominni'}
		  };
		axios(config)
			.then((response)=>{
				if(response.status===200 && response.data){
					setUserAgencyList(response.data);
				}
				
			}).catch((response)=>{
				console.log(response);
			})
	  }
	const fetchData=()=>{
		let _rows=[];
		let _url="";
		let _d={
				token:localStorage.getItem("_xoxex"),
				email:localStorage.getItem("_xoxem"),
			};
		let idata=stringToHex(JSON.stringify(_d));		
	    _url="/api/document/get-documents.php";	
		var config = {
			method: 'post',
			url: API_CORE_SERVER+_url,
			headers: { 
				'Content-Type': 'application/x-www-form-urlencoded',
				//'Content-Type': 'application/json', 
			},
			data:"i="+idata
		  };
		  axios(config).then(response=>{
			if(response.status===200 && response.data){
				let data=response.data;
				if(data.status===1 && data.data && data.data.length>0){
					let records=data.data;
					for(let i=0;i<records.length;i++){
						let assetId=records[i].assetId;
						try{
								let rec=JSON.parse(records[i].data);
								
									if(rec.assetDetail.workStatus==="Ongoing"){
										try{
											let _currentDate=new Date();
											let estWorkStartDate=rec.assetDetail.estWorkStartDate;
											let estWorkCompleteByDays=parseInt(rec.assetDetail.estWorkCompleteByDays);
											let _date=new Date(estWorkStartDate);
											_date.setDate(_date.getDate()+estWorkCompleteByDays);
											if(_currentDate.getTime()>_date.getTime()){
												_rows.push({ 
													assetId:assetId,
													assetType:rec.assetInfo.assetType,
													assetName:rec.assetInfo.assetName,
													implementAgency:rec.assetInfo.implementAgency,
													fundingAgency:rec.assetInfo.fundingAgency,
													userAgency:rec.assetInfo.userAgency,
													assetDescription:rec.assetInfo.assetDescription,
													panchayat:rec.assetInfo.panchayat,
													block:rec.assetInfo.block,
													beneficiary:rec.assetInfo.beneficiary,
													agrCost:rec.assetDetail.agrCost,
													agrDate:rec.assetDetail.agrDate,
													estCost:rec.assetDetail.estCost,
													estWorkStartDate:rec.assetDetail.estWorkStartDate,
													estWorkCompleteByDays:rec.assetDetail.estWorkCompleteByDays,
													workStartDate:rec.assetDetail.workStartDate,
													workFinishDate:rec.assetDetail.workFinishDate,
													workStatus:rec.assetDetail.workStatus,	// Ongoing | Completed | Paused
													workProgress:rec.assetDetail.workProgress, // 5 10 15 20.....100
													lat:rec.assetDetail.lat,
													lng:rec.assetDetail.lng,
													name:rec.contractorInfo.name,
													photos:rec.assetDetail.photos
												});	
												
											}
										}catch(e){}
									}
								
								else _rows.push({ 
									assetId:assetId,
									assetType:rec.assetInfo.assetType,
									assetName:rec.assetInfo.assetName,
									implementAgency:rec.assetInfo.implementAgency,
									fundingAgency:rec.assetInfo.fundingAgency,
									userAgency:rec.assetInfo.userAgency,
									assetDescription:rec.assetInfo.assetDescription,
									panchayat:rec.assetInfo.panchayat,
									block:rec.assetInfo.block,
									beneficiary:rec.assetInfo.beneficiary,
									agrCost:rec.assetDetail.agrCost,
									agrDate:rec.assetDetail.agrDate,
									estCost:rec.assetDetail.estCost,
									estWorkStartDate:rec.assetDetail.estWorkStartDate,
									estWorkCompleteByDays:rec.assetDetail.estWorkCompleteByDays,
									workStartDate:rec.assetDetail.workStartDate,
									workFinishDate:rec.assetDetail.workFinishDate,
									workStatus:rec.assetDetail.workStatus,	// Ongoing | Completed | Paused
									workProgress:rec.assetDetail.workProgress, // 5 10 15 20.....100
									lat:rec.assetDetail.lat,
									lng:rec.assetDetail.lng,
									name:rec.contractorInfo.name,
									photos:rec.assetDetail.photos
								});
							}catch(e){
								console.log("exp:assetId:"+assetId);
							}
					} // for loop
					loadMap(_rows);
				}// if status==1
			}// id status==200
		});
	}
    const loadMap=(_rows)=>{

        let L=window["L"];
        let center=[23.634380, 85.526421];
        var mymap = L.map('mapid').setView(center, 10)

		// add the OpenStreetMap tiles
		L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
			{ 
			attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
			subdomains: ['a', 'b', 'c']
		}).addTo(mymap);
		//http://data.gov.au/geoserver/wa-state-electoral-boundaries-psma-administrative-boundaries/wms?request=GetCapabilities
		
		var nexrad = L.tileLayer.wms("https://gis1.jharkhand.gov.in/gisserver/services/District/Ramgarh_Portal/MapServer/WMSServer", {
			layers: '54',
			styles:'',
			format: 'image/png',
			transparent: true
		}).addTo(mymap);
		/*var nexrad = L.tileLayer.wms("https://gis1.jharkhand.gov.in/gisserver/services/District/Gumla_Portal/MapServer/WMSServer", {
			layers: '55',
			styles:'',
			format: 'image/png',
			transparent: true
		}).addTo(mymap);
		
		var nexrad = L.tileLayer.wms("https://gis1.jharkhand.gov.in/gisserver/services/District/Gumla_Portal/MapServer/WMSServer", {
			layers: '49',
			styles:'',
			format: 'image/png',
			transparent: true
		}).addTo(mymap); // Cadastral Data 
		*/

		//console.log(nexrad);
		L.marker(center).addTo(mymap)
 			.bindPopup('Ramgarh');	//	.openPopup();
		   
				
		var circle = L.circle(center, {
				color: 'red',
				fillColor: '#f03',
				fillOpacity: 0.5,
    				radius: 500
			}).addTo(mymap);
		
		loadMarkers(_rows,mymap,L);
    }
	
	const [showPopup,setShowPopup]=useState(false);
	const loadMarkers=(_rows,_MAP,_L)=>{
		for(let i=0;i<_rows.length;i++){
			try{
				let center=[Number(_rows[i].lat),Number(_rows[i].lng)];
				_L.marker(center).addTo(_MAP)
				.on('click',(e)=>{let _item=_rows[i];setItem(_item);setShowPopup(true);})
			}catch(e_){console.log(e_)};
		}
	}
	return (
        <>
		<GlobalStyles />
		<div className='row'>
		<h5 style={{color:'#000000',fontWeight:450}}><i className='bi bi-boxes'></i> Map</h5>
			<div id="mapidContainer" className="position-relative">
            	<div id="mapid" className=""></div>
				{showPopup===true?
				<div className="position-absolute top-0 end-0 h-100 bg-black-95 p-2" style={{zIndex:999999}}>
					<div className="d-flex">
						<h6 className='w-100'style={{color:'#000000',fontWeight:450}}><i className='bi bi-boxes'></i>Project details</h6>
						<div className="flex-shrink-1 fw-bold cursor-pointer"
							onClick={e=>setShowPopup(false)}
						>Close</div>
					</div>
					<div className="d-flex">
						<div className='formDiv'>
							<div className='formLabel'>Implementing Agency</div>
							<div className='formValue'>{getImplAgencyById(item.implementAgency)}</div>
						</div>
						<div className='formDiv'>
							<div className='formLabel'>Funding Agency</div>
							<div className='formValue'>{item.fundingAgency}</div>
						</div>
						<div className='formDiv'>
							<div className='formLabel'>User Agency</div>
							<div className='formValue'>{getUserAgencyById(item.userAgency)}</div>
						</div>		
					</div>

					<div className='formDiv'>
						<div className='formLabel'>Asset Name</div>
						<div className='formValue'>{item.assetName}</div>
					</div>
					<div className='formDiv'>
						<div className='formLabel'>Description</div>
						<div className='formValue'>{item.assetDescription}</div>
					</div>
					<div className='formDiv'>
						<div className='formLabel'>Asset Type</div>
						<div className='formValue'>{getAssetType(item.assetType)}</div>
					</div>

					<div className='formDiv'>
						<div className='formLabel'>Address</div>
						<div className='formValue'>{item.address}</div>
					</div>

					<div className="d-flex">
						<div className='formDiv'>
							<div className='formLabel'>village</div>
							<div className='formValue'>{item.village}</div>
						</div>
						<div className='formDiv'>
							<div className='formLabel'>Panchayat</div>
							<div className='formValue'>{item.panchayat}</div>
						</div>
						<div className='formDiv'>
							<div className='formLabel'>block</div>
							<div className='formValue'>{item.block}</div>
						</div>
					</div>

					<div className='formDiv'>
						<div className='formLabel'>Beneficiary</div>
						<div className='formValue'>{item.beneficiary}</div>
					</div>

					<div className="d-flex">
						<div className='formDiv'>
							<div className='formLabel'>Agreement cost</div>
							<div className='formValue'>{(item.agrCost)}</div>
						</div>
						<div className='formDiv'>
							<div className='formLabel'>Agreement date</div>
							<div className='formValue'>{(item.agrDate)}</div>
						</div>
						<div className='formDiv'>
							<div className='formLabel'>Estimeted cost</div>
							<div className='formValue'>{(item.estCost)}</div>
						</div>
						<div className='formDiv'>
							<div className='formLabel'>Estimeted work start date</div>
							<div className='formValue'>{(item.estWorkStartDate)}</div>
						</div>
						<div className='formDiv'>
							<div className='formLabel'>Estimeted Work Finsh by days</div>
							<div className='formValue'>{(item.estWorkCompleteByDays)}</div>
						</div>
					</div>

					<div className="d-flex">
						<div className='formDiv'>
							<div className='formLabel'>Work start date</div>
							<div className='formValue'>{(item.workStartDate)}</div>
						</div>
						<div className='formDiv'>
							<div className='formLabel'>Work finsh date</div>
							<div className='formValue'>{(item.workFinishDate)}</div>
						</div>
						<div className='formDiv'>
							<div className='formLabel'>Work status</div>
							<div className='formValue'>{(item.workStatus)}</div>
						</div>
						<div className='formDiv'>
							<div className='formLabel'>Work progress</div>
							<div className='formValue'>{(item.workProgress)}%</div>
						</div>
						
					</div>


				</div>
				:null}
			</div>
		</div>
         </>
    )
}

export default JComponent;